// extracted by mini-css-extract-plugin
export default {"home":"Home_home__qwgF-","title":"Home_title__VS6Y0","picture":"Home_picture__1XLcO","orange":"Home_orange__2HcuK","bee":"Home_bee__fnQ5B","picture__bee":"Home_picture__bee__FR0HA"};